import { TextField } from "@mui/material";
import { AutocompleteAuthors } from "@styleguide";
import { type Control, Controller } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver } from "../logics/types";

export interface IModalActionFormOwnerProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
  hidden?: boolean;
}

export const ModalActionFormOwner = ({ control, hidden = false }: IModalActionFormOwnerProps) => {
  if (hidden) {
    return null;
  }

  return (
    <Controller
      control={control}
      name="owner"
      render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => (
        <AutocompleteAuthors
          value={value}
          onChange={(_, value) => onChange(value)}
          onBlur={onBlur}
          size="small"
          disableCloseOnSelect={false}
          renderInput={(params) => (
            <TextField {...params} label="Auteur *" inputRef={ref} error={Boolean(error)} helperText={error?.message} />
          )}
        />
      )}
    />
  );
};
